import { Component } from 'react';
import { Button, Container, Col, Row, Form } from 'react-bootstrap'
import { connect } from "react-redux";

import TextField from "../common/form/TextField.js";
import translations from "../../config/translation/alert_entry_translations.json"

import { LOADING_STATUES } from "../constants/constants.js";

const mapStateToProps = state => {
  return {
    language: state.languageReducer ? state.languageReducer : 'ENGLISH',
    currentUser: state.currentUserReducer,
    translations: state.translationsReducer
  };
}

const matchDispatchToProps = (dispatch) => {
  return {
    handleLockout: (lockout) => dispatch({ type: 'SET_LOCKOUT_IN_PLACE', lockout })
  }
}

class AlertEntryPhoneRow extends Component {

  state = {
    selectedId: '',
    selectedAlertName: '',
    showDeleteConfirmationDialog: false,
    loadingStatus: "",
    errors: {}
  }

  showLoading = () => {
    if (this.state.loadingStatus === "") {
      this.setState({
        loadingStatus: LOADING_STATUES.LOADING
      })
      return true;
    }
    return false;
  }

  hideLoading = (message, status) => {
    if (status === 'ERROR') {
      this.setState({
        loadingStatus: "",
        submitMessage: ""
      })
    } else {
      this.setState({
        loadingStatus: "",
        submitMessage: message
      })
    }
  }

  render() {

    let disableField = this.props.phone.saved;
    
    let verifiedBadge = <span></span>;
    let resendButton =  <></>;
    let resendMessage = translations[this.props.language].modify_recipient_hint
    if (disableField) {
      if (this.props.phone.validated === false) {
        verifiedBadge = <span className='badge bg-warning text-dark'>Invalid or Opted-out</span>;
      } else if (this.props.phone.verified === true) {
        verifiedBadge = <span className='badge bg-success-darker text-light'>{translations[this.props.language].phone_verified}</span>;
      } else {
        verifiedBadge = <span className='badge bg-warning text-dark'>{translations[this.props.language].verification_needed}</span>;
        resendButton = <Button key={'phoneResend' + this.props.index} variant="secondary" id={'phoneResend' + this.props.index} onClick={this.props.onResend}>{translations[this.props.language].resend}</Button>;
        resendMessage = translations[this.props.language].resend_text_hint
      } 
    }

    let acknowledgement = this.props.acknowledgement;
    if (!this.props.language || this.props.language !== 'ENGLISH' ) {
      acknowledgement = this.props.translations.phoneAcknowledgement;
    }

    return (
      <>
        <fieldset className="borderthick p-2" name={this.props.alertName} style={{ marginRight: 10 }} >
          <legend className="float-none w-auto" style={{ fontSize: '1rem', margin: 0 }} >{translations[this.props.language].text_recipient} {this.props.index + 1}</legend>
          <Row style={{ paddingBottom: 10 }}>
            <Col style={{ paddingLeft: 0 }} lg={12} md={12} sm={12} xs={12}>
              <Container name={this.props.alertName}>
                <Row>
                  <Col lg={6} md={6} sm={6} xs={6}>
                    {verifiedBadge}
                  </Col>
                  <Col className='text-right' style={{ padding: 0 }} lg={6} md={6} sm={6} xs={6}>
                    <Button variant="link" key={'phoneDelete' + this.props.index} id={'phoneDelete' + this.props.index} style={{ paddingTop: 0 }} onClick={this.props.onDelete}><strong>- {translations[this.props.language].remove}</strong></Button>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} md={6} sm={9} xs={9}>
                    <Form.Group controlId={'phoneEntry' + this.props.index} style={{ marginBottom: 0 }} >
                      <TextField formGroup={{ label: translations[this.props.language].cell_phone_number, fieldType: 'tel', labelFor: 'phoneEntry' + this.props.index, value: this.props.phone.value, primaryCriteria: true, placeholder: ' ', disableField: disableField }} onChange={this.props.onChange} />
                      <div style={{ color: "red", fontWeight: "bold" }}> {this.props.errors['phone' + this.props.index]}</div>
                    </Form.Group>
                  </Col>
                  <Col style={{ paddingLeft: 0 }} lg={3} md={3} sm={2} xs={2}>
                    <div>&nbsp;</div>
                    {
                      !disableField &&
                      <Button key={'phoneLookup' + this.props.index} variant="primary" id={'phoneLookup' + this.props.index} onClick={this.props.onClick}>{translations[this.props.language].lookup}</Button>
                    }
                    { resendButton }
                  </Col>
                </Row>
                <Row>
                  {
                    disableField &&
                    <Col style={{ fontSize: '0.8em', marginLeft: 3 }} >
                      {resendMessage}
                    </Col>
                  }
                  {
                    !disableField &&
                    <Col style={{ fontSize: '0.8em', marginLeft: 3 }} >
                      {translations[this.props.language].enter_phone_hint }
                    </Col>
                  }
                </Row>
                <Row>&nbsp;</Row>
                {
                  !disableField &&
                  <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                       {/* checkbox is tricky.  This is the only way I could make the checked attribute works.  It's essentially forcing the checkbox to re-render. */}
                       {
                        this.props.phone.acknowledged && // Show the checkbox only if there's more than 1 thumbnails
                        <Form.Check key={'phoneAcknowledgeChecked' + this.props.index} id={'phoneAcknowledge' + this.props.index} type='checkbox' checked={true} onChange={this.props.onChange} label={acknowledgement} />
                      }
                      {
                        !this.props.phone.acknowledged && // Show the checkbox only if there's more than 1 thumbnails
                        <Form.Check key={'phoneAcknowledgeUnchecked' + this.props.index} id={'phoneAcknowledge' + this.props.index} type='checkbox' checked={false} onChange={this.props.onChange} label={acknowledgement} />
                      }
                         <div style={{ color: "red", fontWeight: "bold" }}> {this.props.errors['phoneAcknowledged' + this.props.index]}</div>
                    </Col>
                  </Row>
                }
              </Container>
            </Col>
          </Row>
        </fieldset>

      </>
    )
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(AlertEntryPhoneRow);